module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_9.00322807.png";